// productos_tut.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderServices from '../Header/HeaderServices';
import FooterServices from '../Footer/FooterServices';
import './productos_tut.css';

const ProductosTut = () => {
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);

  const productos = [
    {
      id: 1,
      nombre: "Arduino UNO R4",
      imagen: "/images/R4/One.png",
      descripcion: "La nueva placa UNO mucho mejor y más completa a tu alcance. Wifi y Bluetooth integrados, una matriz de leds, mayor frecuencia de reloj y más almacenamiento. Todo lo que necesitás para evolucionar tus proyectos",
      precioDesde: "₡16500",
      categoria: "Microcontroladores"
    },
    {
      id: 2,
      nombre: "Superior ESP",
      imagen: "/images/insignia.png",
      descripcion: "El Superior ESP nace del acople del ESP32 tradicional con una placa de expansión que le brinda una mayor autonomía y amplía sus posibilidades.",
      precioDesde: "₡10000",
      categoria: "Microcontroladores"
    },
    {
      id: 3,
      nombre: "Kits de Arduino",
      imagen: "/images/KitsArduino.png",
      descripcion: "Los Kit de Arduino Volteon incluyen todo lo que necesitás para empezar en el mundo de los microcontroladores.",
      precioDesde: "Desde ₡19950",
      categoria: "Kits"
    }
  ];

  const handleProductClick = (producto) => {
    setSelectedProduct(producto);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  const handleBackClick = () => {
    navigate('/tutorial');
  };

  return (
    <div className="productos-tut-wrapper">
      <HeaderServices />

      {/* Hero Section */}
      <section className="productos-tut-hero">
        <div className="productos-tut-hero-container">
          {/* Botón de Regreso */}
          <button onClick={handleBackClick} className="productos-tut-back-btn">
            <span className="productos-tut-back-arrow">←</span>
            Volver
          </button>

          <h1 className="productos-tut-hero-title">
            <span className="productos-tut-hero-title-main">Productos </span>
            <span className="productos-tut-hero-title-accent">Volteon</span>
          </h1>
          <p className="productos-tut-hero-description">
            Descubre nuestra línea completa de productos electrónicos diseñados para tus proyectos. 
            Cada producto incluye manual completo, especificaciones técnicas y soporte dedicado.
          </p>
          <div className="productos-tut-hero-stats">
            <div className="productos-tut-stat">
              <span className="productos-tut-stat-number">Descubre los 3 productos insignia</span>
              <span className="productos-tut-stat-label">Productos</span>
            </div>
            <div className="productos-tut-stat">
              <span className="productos-tut-stat-number">100%</span>
              <span className="productos-tut-stat-label">Calidad</span>
            </div>

          </div>
        </div>
      </section>

      {/* Productos Grid */}
      <section className="productos-tut-grid-section">
        <div className="productos-tut-container">
          <h2 className="productos-tut-section-title">
            <span className="productos-tut-title-accent">Nuestros</span> Productos Destacados
          </h2>
          
          <div className="productos-tut-grid">
            {productos.map((producto) => (
              <div 
                key={producto.id} 
                className="productos-tut-card"
                onClick={() => handleProductClick(producto)}
              >
                <div className="productos-tut-card-image-container">
                  <img 
                    src={producto.imagen} 
                    alt={producto.nombre}
                    className="productos-tut-card-image"
                  />
                  <div className="productos-tut-card-overlay">
                    <span className="productos-tut-card-category">{producto.categoria}</span>
                  </div>
                </div>
                
                <div className="productos-tut-card-content">
                  <h3 className="productos-tut-card-title">{producto.nombre}</h3>
                  <p className="productos-tut-card-description">{producto.descripcion}</p>
                  
                  <div className="productos-tut-card-footer">
                    <span className="productos-tut-card-price">Desde {producto.precioDesde}</span>
                    <button 
                      className="productos-tut-card-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log('Ver detalles:', producto.nombre);
                      }}
                    >
                      Ver Detalles
                      <span className="productos-tut-btn-arrow">→</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedProduct && (
        <div className="productos-tut-modal" onClick={closeModal}>
          <div className="productos-tut-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="productos-tut-modal-close" onClick={closeModal}>×</button>
            
            <div className="productos-tut-modal-grid">
              <div className="productos-tut-modal-image-section">
                <img 
                  src={selectedProduct.imagen} 
                  alt={selectedProduct.nombre}
                  className="productos-tut-modal-image"
                />
              </div>
              
              <div className="productos-tut-modal-info">
                <span className="productos-tut-modal-category">{selectedProduct.categoria}</span>
                <h2 className="productos-tut-modal-title">{selectedProduct.nombre}</h2>
                <p className="productos-tut-modal-description">
                  {selectedProduct.descripcion}
                </p>
                <p className="productos-tut-modal-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt 
                  ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
                  laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                
                <div className="productos-tut-modal-features">
                  <h4>Características:</h4>
                  <ul>
                    <li>✓ Manual de usuario completo incluido</li>
                    <li>✓ Envío gratuito en el ITCR</li>
                  </ul>
                </div>
                
                <div className="productos-tut-modal-price-section">
                  <span className="productos-tut-modal-price">Desde {selectedProduct.precioDesde}</span>
                  <button className="productos-tut-modal-btn">
                    Comprar Ahora
                    <span className="productos-tut-btn-arrow">→</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="productos-tut-cta-section">
        <div className="productos-tut-cta-container">
          <div className="productos-tut-cta-box">
            <h2 className="productos-tut-cta-title">
              ¿No encuentras lo que buscas?
            </h2>
            <p className="productos-tut-cta-description">
              Explora el catálogo completo
            </p>
            <button className="productos-tut-cta-button">
              Contactar Ahora
            </button>
          </div>
        </div>
      </section>

      <FooterServices />
    </div>
  );
};

export default ProductosTut;